import Q4 from 'pages/details/Querter/Q4';
import styled from "styled-components";
import React from 'react';

const QuerterContainer = styled.div`
    height: ${props => props.height - 192}px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    align-items: center;
    background-image : url('assets/images/backgrounds/2560/section8.png');
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 116px;
    padding-bottom: 74px;
    background-position: center;
    @media(max-width:1920px){
        background-image : url('assets/images/backgrounds/1920/section8.png');
    }
    @media(max-width:1440px){
        background-image: url('assets/images/backgrounds/roadmap.png');
        }
        @media (max-width: 1280px) {
        background-image: url('assets/images/backgrounds/1280/section8.png');
    }
    @media(max-width:490px){
        background-image : url('assets/images/backgrounds/mobile/section8.png');
    }
`;
const QuerterBody = styled.div`
    height: ${props => props.height - 194}px;
    overflow: hidden;
    scrollbar-width: none;
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    @media(max-width:490px){
      padding-bottom: 100px;
    }
`;


export default function Querter({ setMoveNext, size, direction }) {
    const querterRef = React.useRef();
     const q4 = React.useRef();
    const [startPoint, setStartPoint] = React.useState(0);
    const handleWheel = (e) => {
        const isBottom = querterRef.current.scrollHeight - Math.floor(querterRef.current.scrollTop) === querterRef.current.clientHeight;
        const isTop = querterRef.current.scrollTop == 0;
        if (direction == 'down') {
            if(isBottom) {
                setMoveNext(true);
            }
            else if(isTop) {
                setMoveNext(true);
            }
            else {
                e.stopPropagation();
            }
        } else {
            if(isTop) {
                setMoveNext(true);    
            }
            else if(isBottom) {
                setMoveNext(true);
            }
            else {
                e.stopPropagation()
            }
        }
    }

    const handleTouchStart = e => {
        e.stopPropagation(); 
    }
  

    return (
        <div >
            <QuerterContainer height={size.height}>
               
                <QuerterBody height={size.height}  onWheel={(e) => handleWheel(e)}  ref={querterRef}>

                    <div ref={q4}>
                     
                        <Q4 size={size}></Q4>
                    </div>
                </QuerterBody>
            </QuerterContainer>
        </div>

    )
}
